import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";
import { analyze } from "../../../redux/ducks/analysis";
import TextInput from "../../dumb/TextInput";

const AnalyzeTask = props => {
    const [show, hide, renderModal] = useModal();
    const [d_analyzeTask, status, error, event] = useStatusThunk(analyze);

    const [name, setName] = useState();

    event.onSuccess = () => {
        hide();
        setName(null);
    }

    const AnTask = () => {
        d_analyzeTask({ projectID: props.projectID, name, taskID: props.taskID });
        setTimeout(() => window.location.reload(), 1000);
    }

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Analyze</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Analysis name</div>
                        <TextInput set={setName} v={name} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--primary" onClick={() => AnTask()}>Analyze Task</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default AnalyzeTask;